import { useEffect, useState, useContext } from "react";
import NAVBAR from "components/navbar";
import api from "services/api";
import config from 'config';
import FOOTER from "components/footer";
import { CidadeContext } from "services/cidade";
import { formatNumber } from "components/formatos";
import CARDBOX from "../home/components/box";
import Tabs from "components/tabs/tabs";
import TABLEPAGINADA from "components/tablepaginada";
import './style.css';

function AdminCashBack() {
    const [objcb, setObjcb] = useState([]);
    const { cod_cidade } = useContext(CidadeContext);
    
    // Estados para paginação de Estabs
    const [pageEstabs, setPageEstabs] = useState(0);
    const [maxItensEstabs] = useState(10);
    
    // Estados para paginação de Usuarios
    const [pageUsuarios, setPageUsuarios] = useState(0);
    const [maxItensUsuarios] = useState(10);

    useEffect(() => {
        api.get(`${config.CASHBACK_DASHBOARD}?cod_cidade=${cod_cidade}`)
            .then(response => {
                setObjcb(response.data);
            })
            .catch(err => {
                console.log('Erro ao carregar cashback:', err);
            });
    }, [cod_cidade]);

    // Agrupar entidades por conta
    const agruparPorConta = () => {
        if (!objcb.entidades) return {};
        
        const agrupado = {};
        objcb.entidades.forEach(entidade => {
            if (!agrupado[entidade.conta]) {
                agrupado[entidade.conta] = [];
            }
            agrupado[entidade.conta].push(entidade);
        });
        return agrupado;
    };

    const entidadesPorConta = agruparPorConta();


    // Preparar dados para tabela de Estabs
    const headerEstabs = ['ID Estabelecimento', 'Nome', 'Valor a Pagar (ACTUS)', 'Valor a Receber (ACTUS)'];
    const estabs = objcb.estabs || [];
    const bodyEstabs = estabs.slice(pageEstabs * maxItensEstabs, (pageEstabs + 1) * maxItensEstabs).map(estab => [
        estab.id_estabelecimento,
        estab.nome,
        { content: formatNumber(estab.valorpagaractus), className: 'text-end' },
        { content: formatNumber(estab.valorreceberactus), className: 'text-end' }
    ]);
    // Totais
    const totalPagarEstabs = estabs.reduce((acc, cur) => acc + (Number(cur.valorpagaractus) || 0), 0);
    const totalReceberEstabs = estabs.reduce((acc, cur) => acc + (Number(cur.valorreceberactus) || 0), 0);
    const footEstabs = [
        { content: <b>Total</b> },
        '',
        { content: <b>{formatNumber(totalPagarEstabs)}</b>, className: 'text-end' },
        { content: <b>{formatNumber(totalReceberEstabs)}</b>, className: 'text-end' }
    ];
    const countEstabs = estabs.length;
    const pagesEstabs = Math.ceil(countEstabs / maxItensEstabs);

    // Preparar dados para tabela de Usuarios
    const headerUsuarios = ['ID Usuário', 'Nome', 'Valor Pendente', 'Valor Disponível'];
    const usuarios = objcb.usuarios || [];
    const bodyUsuarios = usuarios.slice(pageUsuarios * maxItensUsuarios, (pageUsuarios + 1) * maxItensUsuarios).map(usuario => [
        usuario.id_usuario,
        usuario.nome,
        { content: formatNumber(usuario.valorpendente), className: 'text-end' },
        { content: formatNumber(usuario.valordisponivel), className: 'text-end' }
    ]);
    // Totais
    const totalPendenteUsuarios = usuarios.reduce((acc, cur) => acc + (Number(cur.valorpendente) || 0), 0);
    const totalDisponivelUsuarios = usuarios.reduce((acc, cur) => acc + (Number(cur.valordisponivel) || 0), 0);
    const footUsuarios = [
        { content: <b>Total</b> },
        '',
        { content: <b>{formatNumber(totalPendenteUsuarios)}</b>, className: 'text-end' },
        { content: <b>{formatNumber(totalDisponivelUsuarios)}</b>, className: 'text-end' }
    ];
    const countUsuarios = usuarios.length;
    const pagesUsuarios = Math.ceil(countUsuarios / maxItensUsuarios);

    return (
        <div>
            <NAVBAR />
            <div className="mt-page">
                <h1>CashBack</h1>
                
                <div className="linhas-card">
                    <div className="row mt-2">
                        {Object.entries(entidadesPorConta).map(([conta, entidades]) => (
                            <div key={conta} className="col-md-3 mb-3">
                                <CARDBOX
                                    header={conta}
                                    titile={conta}
                                    text={
                                        <div className="entidades-list">
                                            {entidades.map((ent, idx) => (
                                                <div key={idx} className="entidade-row">
                                                    <span className="entidade-tipo">{ent.entidade_tipo}</span>
                                                    <span className="entidade-valor">{formatNumber(ent.valor)}</span>
                                                </div>
                                            ))}
                                        </div>
                                    }
                                />
                            </div>
                        ))}
                    </div>
                </div>

                <div className="linhas-card mt-5">
                    <h2>Detalhes</h2>
                    <Tabs>
                        <div label='Estabelecimentos'>
                            <TABLEPAGINADA
                                header={headerEstabs}
                                body={bodyEstabs}
                                foot={footEstabs}
                                count={countEstabs}
                                page={pageEstabs}
                                maxitens={maxItensEstabs}
                                pages={pagesEstabs}
                                onPageChange={setPageEstabs}
                            />
                        </div>
                        <div label='Usuários'>
                            <TABLEPAGINADA
                                header={headerUsuarios}
                                body={bodyUsuarios}
                                foot={footUsuarios}
                                count={countUsuarios}
                                page={pageUsuarios}
                                maxitens={maxItensUsuarios}
                                pages={pagesUsuarios}
                                onPageChange={setPageUsuarios}
                            />
                        </div>
                    </Tabs>
                </div>
            </div>
            <FOOTER />
        </div>
    );
}

export default AdminCashBack;